import { React, useState } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckCircle,
  faExclamationTriangle,
  faInfoCircle,
  faQuestionCircle,
  faTimes
} from '@fortawesome/pro-solid-svg-icons';
import { OverlayTrigger, Popover, Alert } from 'react-bootstrap';

const VALID_TYPES = ['danger', 'info', 'success', 'warning'];

export default function Banner({
  bannerClass,
  bannerIconClass,
  bannerIconType,
  bannerIconSize,
  bannerStyle,
  content,
  dismissOnClick,
  handleDismiss,
  infoIconClass,
  infoIconSize,
  infoMessage
}) {
  const [show, setShow] = useState(true);
  const selectIcon = (iconType) => {
    switch (iconType) {
    case 'danger':
      return faExclamationTriangle;
    case 'error':
      return faTimes;
    case 'info':
      return faInfoCircle;
    case 'question':
      return faQuestionCircle;
    case 'success':
      return faCheckCircle;
    default:
      return null;
    }
  };

  const renderIcon = (iconClass, iconType, iconName, iconSize) => {
    const selectedIcon = selectIcon(iconType);

    if (!selectedIcon) return null;

    return (
      <FontAwesomeIcon
        className={iconClass}
        icon={selectedIcon}
        name={iconName}
        size={iconSize}
      />
    );
  };

  const renderBannerIcon = () => {
    const icon = renderIcon(bannerIconClass, bannerIconType, 'banner-icon', bannerIconSize);

    if (!icon) return null;

    return <div className="align-self-center px-3">{icon}</div>;
  };

  const renderMoreInfo = () => {
    const icon = renderIcon(infoIconClass, 'question', 'info-icon', infoIconSize);

    if (!icon || !infoMessage) return null;

    const overlay = (
      <Popover className="max-full-width" id="info-description">
        {infoMessage}
      </Popover>
    );

    return (
      <div className="align-self-center px-3" style={{ marginLeft: 'auto' }}>
        <OverlayTrigger overlay={overlay} placement="top">{icon}</OverlayTrigger>
      </div>
    );
  };

  const dismissAction = () => {
    if (handleDismiss != undefined) {
      return handleDismiss;
    } else if (dismissOnClick == true) {
      return () => {
        setShow(false);
      };
    }
  };

  function renderAlert() {
    if (show) {
      return (
        <Alert
          bsStyle={VALID_TYPES.includes(bannerStyle) ? bannerStyle : 'info'}
          className={bannerClass}
          onDismiss={dismissAction()}
        >
          <div className="d-flex">
            {renderBannerIcon()}
            {content}
            {renderMoreInfo()}
          </div>
        </Alert>
      );
    } else {
      return null;
    }
  }

  return (
    renderAlert()
  );
}

Banner.propTypes = {
  bannerClass: PropTypes.string,
  bannerIconClass: PropTypes.string,
  bannerIconSize: PropTypes.string,
  bannerIconType: PropTypes.oneOf(VALID_TYPES),
  bannerStyle: PropTypes.oneOf(VALID_TYPES),
  content: PropTypes.any,
  dismissOnClick: PropTypes.bool,
  handleDismiss: PropTypes.func,
  infoIconClass: PropTypes.string,
  infoIconSize: PropTypes.string,
  infoMessage: PropTypes.any
};

Banner.defaultProps = {
  bannerIconSize: 'lg',
  bannerStyle: 'info',
  dismissOnClick: false,
  infoIconSize: 'lg'
};
